import { createFileRoute } from "@tanstack/react-router";

import Royalties from "@/features/royalties/royalties";

export const Route = createFileRoute("/_auth/royalties")({
  component: Royalties,
});
